var _rect, _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgDoc = function SvgDoc(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_857_31110",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 20,
    height: 20
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_857_31110)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.07258 13.9293H12.0726V12.4293H6.07258V13.9293ZM6.07258 10.75H13.9313V9.24998H6.07258V10.75ZM6.07258 7.57063H13.9313V6.07063H6.07258V7.57063ZM4.64325 17.4004C4.07374 17.4004 3.59108 17.2025 3.19527 16.8067C2.79947 16.4108 2.60156 15.9282 2.60156 15.3587V4.6413C2.60156 4.07178 2.79947 3.58912 3.19527 3.19332C3.59108 2.79751 4.07374 2.59961 4.64325 2.59961H15.3606C15.9301 2.59961 16.4128 2.79751 16.8086 3.19332C17.2044 3.58912 17.4023 4.07178 17.4023 4.6413V15.3587C17.4023 15.9282 17.2044 16.4108 16.8086 16.8067C16.4128 17.2025 15.9301 17.4004 15.3606 17.4004H4.64325ZM4.64325 15.3587H15.3606V4.6413H4.64325V15.3587Z",
    fill: "#0040BF"
  }))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgDoc);
export default ForwardRef;